export default "__VITE_ASSET__WKmGM8Uh__"